<template>
    <van-popup class="share-change-group-popup other-share-change-group-popup" 
        v-bind:value="showPop" 
        v-bind:close-on-click-overlay="overlayClickClose"
        @click-overlay='clickOverlay'>
        <div class="share-cgpp-title">{{setting[shareType].title}}</div>
        <div class="share-cgpp-item">
            <label class="collate-form-label">{{setting[shareType].label1}}</label>
            <input class="collate-form-input" type="text" maxlength="15" v-bind:placeholder="setting[shareType].placehold1" @input="changeName" v-model="shareFormData.f_name" autofocus>
        </div>
        <div class="share-cgpp-item" @click="chooseGroup">
            <label class="collate-form-label">{{setting[shareType].label2}}</label>
            <div class="share-cgpp-choose">
                <span v-if="shareFormData.group && shareFormData.group != ''" class="share-cgpp-text-have">{{shareFormData.group.slice(0, 10)}}</span>
                <span v-else class="share-cgpp-text">选择分组</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
        </div>
        <div class="share-cgpp-item">
            <label class='collate-form-label'>{{setting[shareType].label3}}</label>
            <input class="collate-form-input" type="text" maxlength="15" v-bind:placeholder="setting[shareType].placehold2" @input="changeParentName" v-model="shareFormData.shareTitle">
        </div>
        <div class="share-cgpp-button" @click="confirmChange">{{setting[shareType].saveText}}</div>
    </van-popup>
</template>

<script>
export default {
    name: 'VantShareChangePop',
    props: [
        'shareType', 
        'showPop',
        'overlayClickClose',
        'overlayFunc',
        'shareFormData',
        'changeNameFunc',
        'changeParentNameFunc',
        'chooseGroupFunc',
        'confimChangeFunc'
    ],
    data() {
        return {
            setting: {
                '3': {
                    title: '确定新八字名称、分组及批盘名称',
                    label1: '八字名称',
                    label2: '八字分组',
                    label3: '批盘名称',
                    placehold1: '输入八字名称',
                    placehold2: '输入批盘名称',
                    saveText: '确定'
                },
                '6': {
                    title: '确定新八字名称、分组及论盘名称',
                    label1: '八字名称',
                    label2: '八字分组',
                    label3: '论盘名称',
                    placehold1: '输入八字名称',
                    placehold2: '输入论盘名称',
                    saveText: '确定并进入论盘'
                }
            },
            confirmLock: false
        }
    },
    methods: {
        clickOverlay() {
            if(this.overlayFunc && typeof(this.overlayFunc) == 'function') {
                this.overlayFunc();
            }
        },
        changeName() {
            if(this.changeNameFunc && typeof(this.changeNameFunc) == 'function') {
                this.changeNameFunc();
            }
        },
        changeParentName() {
            if(this.changeParentNameFunc && typeof(this.changeParentNameFunc) == 'function') {
                this.changeParentNameFunc();
            }
        },
        chooseGroup() {
            if(this.chooseGroupFunc && typeof(this.chooseGroupFunc) == 'function') {
                this.chooseGroupFunc();
            }
        },
        confirmChange() {
            // 校验值
            console.log('confirmChange-----', this.shareFormData.f_name, this.shareFormData.shareTitle)
            if(this.confirmLock) {
                return;
            }

            this.confirmLock = true;
            if(this.shareFormData.f_name == '') {
                this.$toast('八字名称不能为空');
                return;
            }
            if(this.shareFormData.shareTitle == '') {
                this.$toast('批盘名称不能为空');
                return;
            }

            var me = this;
            if(this.confimChangeFunc && typeof(this.confimChangeFunc) == 'function') {
                this.confimChangeFunc({
                    cb: function(){
                        me.confirmLock = false;
                    }
                });
            }
        }
    }
}
</script>